import { render, staticRenderFns } from "./SingleDesignHero.vue?vue&type=template&id=3017fef8&scoped=true&"
import script from "./SingleDesignHero.vue?vue&type=script&lang=js&"
export * from "./SingleDesignHero.vue?vue&type=script&lang=js&"
import style0 from "./SingleDesignHero.vue?vue&type=style&index=0&id=3017fef8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3017fef8",
  null
  
)

export default component.exports